
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { motion } from 'framer-motion';
import { ArrowLeft, Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import SettingsSection from '@/components/SettingsSection';

const SettingsPage: React.FC = () => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const isMobile = useIsMobile();
  
  useEffect(() => {
    if (!loading && !currentUser) {
      navigate('/login');
    }
  }, [currentUser, loading, navigate]);
  
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  return (
    <div className={cn(
      "container mx-auto px-4 py-8",
      isDark ? 'text-slate-200' : 'text-slate-900',
      isMobile ? "max-w-full" : "max-w-5xl"
    )}>
      <div className="mb-6 pt-4">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft size={16} />
          Back
        </Button>
      </div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="space-y-4"
      >
        <h1 className={cn(
          "text-2xl font-bold text-center flex items-center justify-center gap-2",
          isDark ? "text-slate-200" : "text-slate-900"
        )}>
          <Settings size={20} className={isDark ? "text-blue-400" : "text-blue-600"} />
          Settings
        </h1>
        
        <div className="flex flex-col items-center">
          <SettingsSection />
        </div>
      </motion.div>
    </div>
  );
};

export default SettingsPage;
